import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Observable } from 'rxjs';
import { AuthResponse } from 'src/app/shared/models/api-response/auth-response';
import { ConstantsService } from '../constant/constants.service';
import { DataStorageService } from '../dataStorage/data-storage.service';
import { GenericCrudService } from '../generic-crud.service';
import { PasswordResetToken } from 'src/app/shared/models/passwordResetToken';
import { AuthResponseIsy } from 'src/app/shared/models/auth-response-isy';
import { FacadeService } from '../facade.service';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';

class AuthRequest {
	username: string;
	password: string;
}

class AuthRequestIsy {
	login: string;
	password: string;
}

class RefreshTokenRequest {
	username: string;
	refreshToken: string;
}

@Injectable({
	providedIn: 'root'
})
export class AuthenticationService {
	constructor(
		private appConstants: ConstantsService,
		private jwtHelper: JwtHelperService,
		private router: Router,
		private dataStorageService: DataStorageService,
		private genericCrudService: GenericCrudService,
		private facade: FacadeService
	) {}

	authIsyUrl = `https://pvyv02.isycare-technology.com/affectation/auth/signin`;

	authenticate(login: string, password: string): Observable<AuthResponse> {
		const request: AuthRequest = new AuthRequest();
		request.username = login;
		request.password = password;
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.authUrl}/signin`,
			`authenticate`,
			request
		);
	}

	authenticateIsy(login: string, password: string): Observable<AuthResponseIsy> {
		const request: AuthRequestIsy = new AuthRequestIsy();
		request.login = login;
		request.password = password;
		return this.genericCrudService.genericPostDataToAPI(
			this.authIsyUrl,
			`authenticateIsy`,
			request
		);
	}

	public isAuthenticated(): boolean {
		console.log(this.dataStorageService.getJwtToken());
		const token = this.dataStorageService.getJwtToken();
		const refreshToken = this.dataStorageService.getRefreshToken();
		if (!token && !refreshToken) {
			return false;
		}
		//return !this.jwtHelper.isTokenExpired(token);
		return true;
	}

	public confirmAccount(token: string): Observable<any> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.authUrl}/confirm/${token}`,
			'confirmAccount'
		);
	}

	public setPasswordConfirmationAccount(
		token: string,
		password: string
	): Observable<any> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.authUrl}/confirm/${token}`,
			`setPasswordConfirmationAccount`,
			password
		);
	}

	public refreshToken(username: string, refreshToken: string): Observable<AuthResponse> {
		const request: RefreshTokenRequest = new RefreshTokenRequest();
		request.username = username;
		request.refreshToken = refreshToken;
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.authUrl}/refreshToken`,
			`refreshToken`,
			request
		);
	}

	public retrievePassword(email: string): Observable<PasswordResetToken> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.authUrl}/forgotPassword/${email}`,
			'retrievePassword'
		);
	}

	clearStorage() {
		this.facade.dataStorageService.clearStorage();
		this.facade.dataStorageService.clearSession();
		this.facade.messageService.ngOnDestroy();
	}

	checkIsAuthenticated(){
		// const hasLogOut = this.facade.dataStorageService.getJwtToken() === '';
		// if (hasLogOut || !this.isAuthenticated()) {
		// 	this.clearStorage();
		// 	this.router.navigate([`/login`], { replaceUrl: true });
		// 	return false;
		// }
		return true;
	}

	isTokenExpired(token: string): boolean {
		if (!token) return true;
		
		const decoded: any = jwtDecode(token);
		return decoded.exp * 1000 < Date.now(); 
	}

	signOut() {
		//this.facade.notificationService.ngOnDestroy();
		this.facade.messageService.ngOnDestroy();
		this.facade.dataStorageService.clearStorage();
		this.facade.dataStorageService.setJwtToken('');
		this.facade.dataStorageService.setRefreshToken('');
		location.reload();
	}

}
